(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/ticket-carousel/ticket-carousel-helpers.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/ticket-carousel/ticket-carousel-helpers.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const getShadowState = svs.tickets.next.components.ticketWithPodiumShadow.getShadowState;
const TICKET_COUNT = 31;
const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';
const DESKTOP_FULL_STACK_WIDTH = 1400;
const DESKTOP_COMPACT_VISIBLE_SIDE_COUNT = 5;
const DESKTOP_FULL_VISIBLE_SIDE_COUNT = 8;
const DESKTOP_ARROW_SIZE = 28;
const DESKTOP_ARROW_MIN_PADDING = 8;
const DESKTOP_ARROW_MAX_PADDING = 28;
const DESKTOP_ARROW_PADDING_RATIO = 0.015;
const DESKTOP_ARROW_STACK_GAP_MIN = 82;
const DESKTOP_ARROW_STACK_GAP_MAX = 128;
const DESKTOP_ARROW_STACK_GAP_RATIO = 0.38;
const DESKTOP_INTRO_DELAY_MS = 120;
const DESKTOP_INTRO_DURATION_MS = 940;
const DESKTOP_INTRO_CENTER_PHASE = 0.34;
const DESKTOP_INTRO_STACK_PHASE = 0.61;
const DRAG_TICKET_FACTOR = 0.0062;
const DRAG_THRESHOLD_PX = 6;
const MOBILE_INTRO_DELAY_MS = 90;
const MOBILE_INTRO_DURATION_MS = 900;
const MOBILE_INTRO_CENTER_PHASE = 0.52;
const MOBILE_INTRO_STACK_REVEAL_START = 0.62;
const MOMENTUM_FRAME_MS = 16;
const MOMENTUM_FRICTION = 0.92;
const MIN_VELOCITY = 0.004;
const SNAP_DURATION_MS = 220;
const SNAP_THRESHOLD = 0.001;
const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
const easeOutCubic = progress => 1 - (1 - progress) ** 3;
const easeInOutCubic = progress => {
  if (progress < 0.5) {
    return 4 * progress ** 3;
  }
  return 1 - (-2 * progress + 2) ** 3 / 2;
};
const getGsap = () => typeof window === 'undefined' ? null : window.gsap;
const wrap = function (value) {
  let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TICKET_COUNT;
  return (value % length + length) % length;
};
const getWrappedDistance = (index, position) => {
  const normalizedPosition = wrap(position);
  return wrap(index - normalizedPosition + TICKET_COUNT / 2) - TICKET_COUNT / 2;
};
const getNearestPosition = position => Math.round(position);
const getImageSource = function () {
  let image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return image.src || image.url || image.noscriptUrl || image.originalUrl || '';
};
const getSkinImage = skin => (skin === null || skin === void 0 ? void 0 : skin.image) || skin || null;
const getSkinVariationCount = _ref => {
  let skins = _ref.skins,
    variations = _ref.variations;
  if (!Array.isArray(skins) || !skins.length) {
    return 0;
  }
  const variationNumber = Number(variations);
  if (Number.isFinite(variationNumber) && variationNumber > 0) {
    return Math.min(variationNumber, skins.length);
  }
  return skins.length;
};
const getTicketImage = _ref2 => {
  let image = _ref2.image,
    skins = _ref2.skins,
    ticketNumber = _ref2.ticketNumber,
    variations = _ref2.variations;
  const variationCount = getSkinVariationCount({
    skins,
    variations
  });
  if (!variationCount) {
    return image;
  }
  return getSkinImage(skins[(ticketNumber - 1) % variationCount]) || image;
};
const getCarouselImageSourceKey = _ref3 => {
  let image = _ref3.image,
    skins = _ref3.skins,
    variations = _ref3.variations;
  const variationCount = getSkinVariationCount({
    skins,
    variations
  });
  if (!variationCount) {
    return getImageSource(image);
  }
  return skins.slice(0, variationCount).map(skin => getImageSource(getSkinImage(skin))).join('|');
};
const getTicketNumberFromPosition = position => wrap(getNearestPosition(position)) + 1;
const getSafeTicketNumber = function (ticketNumber) {
  let fallbackTicketNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const parsedTicketNumber = parseInt(ticketNumber, 10);
  if (!Number.isFinite(parsedTicketNumber) || parsedTicketNumber < 1) {
    return fallbackTicketNumber;
  }
  return wrap(parsedTicketNumber - 1) + 1;
};
const getTicketPositionFromNumber = ticketNumber => getSafeTicketNumber(ticketNumber) - 1;
const getClosestPositionForTicketNumber = _ref4 => {
  let _ref4$position = _ref4.position,
    position = _ref4$position === void 0 ? 0 : _ref4$position,
    ticketNumber = _ref4.ticketNumber;
  const ticketPosition = getTicketPositionFromNumber(ticketNumber);
  const wrappedOffset = Math.round((position - ticketPosition) / TICKET_COUNT) * TICKET_COUNT;
  return ticketPosition + wrappedOffset;
};
const getViewportWidth = () => {
  var _document$documentEle;
  if (typeof window === 'undefined') {
    return 0;
  }
  return window.innerWidth || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.clientWidth) || 0;
};
const useCarouselViewport = () => {
  const _useState = useState(() => {
      const viewportWidth = getViewportWidth();
      if (typeof window === 'undefined' || !window.matchMedia) {
        return {
          isDesktop: viewportWidth >= 1024,
          viewportWidth
        };
      }
      return {
        isDesktop: window.matchMedia(DESKTOP_MEDIA_QUERY).matches,
        viewportWidth
      };
    }),
    _useState2 = _slicedToArray(_useState, 2),
    viewportState = _useState2[0],
    setViewportState = _useState2[1];
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return undefined;
    }
    const mediaQueryList = window.matchMedia(DESKTOP_MEDIA_QUERY);
    const update = () => {
      setViewportState({
        isDesktop: mediaQueryList.matches,
        viewportWidth: getViewportWidth()
      });
    };
    update();
    window.addEventListener('resize', update);
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener('change', update);
      return () => {
        mediaQueryList.removeEventListener('change', update);
        window.removeEventListener('resize', update);
      };
    }
    mediaQueryList.addListener(update);
    return () => {
      mediaQueryList.removeListener(update);
      window.removeEventListener('resize', update);
    };
  }, []);
  return viewportState;
};
const useCarouselIntro = _ref5 => {
  let imageSource = _ref5.imageSource,
    isDesktop = _ref5.isDesktop;
  const _useState3 = useState(isDesktop ? 1 : 0),
    _useState4 = _slicedToArray(_useState3, 2),
    introProgress = _useState4[0],
    setIntroProgress = _useState4[1];
  const introFrameRef = useRef(null);
  const introDelayRef = useRef(null);
  const introTweenRef = useRef(null);
  const cancelIntro = useCallback(() => {
    if (introDelayRef.current) {
      window.clearTimeout(introDelayRef.current);
      introDelayRef.current = null;
    }
    if (introFrameRef.current) {
      cancelAnimationFrame(introFrameRef.current);
      introFrameRef.current = null;
    }
    if (introTweenRef.current) {
      introTweenRef.current.kill();
      introTweenRef.current = null;
    }
  }, []);
  const finishIntro = useCallback(() => {
    cancelIntro();
    setIntroProgress(1);
  }, [cancelIntro]);
  useEffect(() => {
    var _window$matchMedia, _window;
    cancelIntro();
    const reduceMotion = (_window$matchMedia = (_window = window).matchMedia) === null || _window$matchMedia === void 0 || (_window$matchMedia = _window$matchMedia.call(_window, '(prefers-reduced-motion: reduce)')) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.matches;
    if (reduceMotion) {
      setIntroProgress(1);
      return undefined;
    }
    setIntroProgress(0);
    const introDelayMs = isDesktop ? DESKTOP_INTRO_DELAY_MS : MOBILE_INTRO_DELAY_MS;
    const introDurationMs = isDesktop ? DESKTOP_INTRO_DURATION_MS : MOBILE_INTRO_DURATION_MS;
    const startIntro = () => {
      const gsap = getGsap();
      const progressState = {
        value: 0
      };
      if (gsap) {
        introTweenRef.current = gsap.to(progressState, {
          value: 1,
          duration: introDurationMs / 1000,
          ease: 'power1.out',
          onUpdate: () => {
            setIntroProgress(progressState.value);
          },
          onComplete: () => {
            introTweenRef.current = null;
            setIntroProgress(1);
          }
        });
        return;
      }
      const startTime = performance.now();
      const tick = timestamp => {
        const nextProgress = clamp((timestamp - startTime) / introDurationMs, 0, 1);
        setIntroProgress(nextProgress);
        if (nextProgress < 1) {
          introFrameRef.current = requestAnimationFrame(tick);
          return;
        }
        introFrameRef.current = null;
      };
      introFrameRef.current = requestAnimationFrame(tick);
    };
    introDelayRef.current = window.setTimeout(startIntro, introDelayMs);
    return cancelIntro;
  }, [cancelIntro, imageSource, isDesktop]);
  return {
    finishIntro,
    introProgress
  };
};
const getBadgeSize = _ref6 => {
  let _ref6$panelWidth = _ref6.panelWidth,
    panelWidth = _ref6$panelWidth === void 0 ? 0 : _ref6$panelWidth,
    _ref6$panelHeight = _ref6.panelHeight,
    panelHeight = _ref6$panelHeight === void 0 ? 0 : _ref6$panelHeight,
    _ref6$scale = _ref6.scale,
    scale = _ref6$scale === void 0 ? 1 : _ref6$scale,
    isDesktop = _ref6.isDesktop;
  const baseSize = Math.min(panelWidth, panelHeight) * (isDesktop ? 0.18 : 0.12);
  const scaledSize = baseSize / Math.max(scale, 0.0001);
  return clamp(scaledSize, isDesktop ? 22 : 24, isDesktop ? 30 : 26);
};
const getDesktopCardShadow = _ref7 => {
  let absOffset = _ref7.absOffset,
    direction = _ref7.direction;
  if (absOffset < 0.5) {
    return '0 10px 20px rgba(0, 0, 0, 0.14)';
  }
  const shadowDirection = direction < 0 ? -1 : 1;
  const layerOpacity = clamp(0.2 - absOffset * 0.012, 0.08, 0.18);
  return "".concat(shadowDirection * 4, "px 0 7px rgba(0, 0, 0, ").concat(layerOpacity, "), 0 3px 7px rgba(0, 0, 0, 0.06)");
};
const getItemLayout = _ref8 => {
  let offset = _ref8.offset,
    panelWidth = _ref8.panelWidth,
    panelHeight = _ref8.panelHeight,
    isDesktop = _ref8.isDesktop;
  const absOffset = Math.abs(offset);
  const direction = offset < 0 ? -1 : 1;
  const centerBlend = clamp(absOffset, 0, 1);
  const sideDepth = Math.max(absOffset - 1, 0);
  const sideScale = isDesktop ? 0.82 : 0.86;
  const sideStart = panelWidth * (isDesktop ? 1.02 : 0.96);
  const sideStep = isDesktop ? clamp(panelWidth * 0.07, 8, 12) : panelWidth * 0.18;
  const sideX = direction * (sideStart + sideDepth * sideStep);
  const x = centerBlend < 1 ? sideX * centerBlend : sideX;
  const scale = absOffset < 1 ? 1 - (1 - sideScale) * absOffset : Math.max(sideScale - sideDepth * 0.002, sideScale - 0.04);
  const y = Math.min(absOffset, 1) * panelHeight * (isDesktop ? 0.015 : 0);
  const boxShadow = isDesktop ? getDesktopCardShadow({
    absOffset,
    direction
  }) : 'none';
  let opacity = 1;
  if (!isDesktop && absOffset > 1) {
    opacity = clamp(2 - absOffset, 0, 1);
  }
  const zIndex = absOffset < 0.5 ? 220 : 160 - Math.round(absOffset * 4);
  return {
    absOffset,
    boxShadow,
    direction,
    opacity,
    scale,
    x,
    y,
    zIndex
  };
};
const getDesktopVisibleSideCount = _ref9 => {
  let isDesktop = _ref9.isDesktop,
    viewportWidth = _ref9.viewportWidth;
  if (!isDesktop) {
    return 1.75;
  }
  return viewportWidth && viewportWidth < DESKTOP_FULL_STACK_WIDTH ? DESKTOP_COMPACT_VISIBLE_SIDE_COUNT : DESKTOP_FULL_VISIBLE_SIDE_COUNT;
};
const getDesktopArrowOffset = _ref0 => {
  let panelWidth = _ref0.panelWidth,
    _ref0$visibleSideCoun = _ref0.visibleSideCount,
    visibleSideCount = _ref0$visibleSideCoun === void 0 ? DESKTOP_FULL_VISIBLE_SIDE_COUNT : _ref0$visibleSideCoun,
    _ref0$viewportWidth = _ref0.viewportWidth,
    viewportWidth = _ref0$viewportWidth === void 0 ? 0 : _ref0$viewportWidth;
  const sideScale = 0.82;
  const sideStart = panelWidth * 1.02;
  const sideStep = clamp(panelWidth * 0.07, 8, 12);
  const outerSideDepth = Math.max(visibleSideCount - 1, 0);
  const outerStackEdge = sideStart + outerSideDepth * sideStep + panelWidth * sideScale / 2;
  const stackGap = clamp(panelWidth * DESKTOP_ARROW_STACK_GAP_RATIO, DESKTOP_ARROW_STACK_GAP_MIN, DESKTOP_ARROW_STACK_GAP_MAX);
  const idealOffset = Math.max(outerStackEdge + stackGap, 235);
  if (!viewportWidth) {
    return idealOffset;
  }
  const viewportPadding = clamp(viewportWidth * DESKTOP_ARROW_PADDING_RATIO, DESKTOP_ARROW_MIN_PADDING, DESKTOP_ARROW_MAX_PADDING);
  const maxVisibleOffset = Math.max(0, viewportWidth / 2 - viewportPadding - DESKTOP_ARROW_SIZE / 2);
  return Math.min(idealOffset, maxVisibleOffset);
};
const createCarouselItems = _ref1 => {
  let isDesktop = _ref1.isDesktop,
    _ref1$panelWidth = _ref1.panelWidth,
    panelWidth = _ref1$panelWidth === void 0 ? 0 : _ref1$panelWidth,
    _ref1$panelHeight = _ref1.panelHeight,
    panelHeight = _ref1$panelHeight === void 0 ? 0 : _ref1$panelHeight,
    _ref1$position = _ref1.position,
    position = _ref1$position === void 0 ? 0 : _ref1$position,
    visibleSideCount = _ref1.visibleSideCount;
  const safePanelWidth = Math.max(panelWidth, 1);
  const safePanelHeight = Math.max(panelHeight, 1);
  const resolvedVisibleSideCount = visibleSideCount || (isDesktop ? (TICKET_COUNT - 1) / 2 : 1.75);
  return Array.from({
    length: TICKET_COUNT
  }, (_, index) => {
    const offset = getWrappedDistance(index, position);
    const layout = getItemLayout({
      offset,
      panelWidth: safePanelWidth,
      panelHeight: safePanelHeight,
      isDesktop
    });
    return _objectSpread(_objectSpread({}, layout), {}, {
      isSelected: Math.abs(offset) < 0.5,
      isVisible: layout.absOffset <= resolvedVisibleSideCount,
      key: "ticket-carousel-".concat(index + 1),
      number: index + 1,
      offset,
      width: safePanelWidth,
      height: safePanelHeight
    });
  }).filter(item => item.isVisible || item.opacity > 0.01).sort((leftItem, rightItem) => leftItem.zIndex - rightItem.zIndex);
};
const getDesktopIntroItemLayout = _ref10 => {
  let item = _ref10.item,
    progress = _ref10.progress;
  if (item.isSelected) {
    const centerProgress = easeOutCubic(clamp(progress / DESKTOP_INTRO_CENTER_PHASE, 0, 1));
    return _objectSpread(_objectSpread({}, item), {}, {
      opacity: centerProgress,
      scale: 0.92 + centerProgress * 0.08,
      y: item.y - (1 - centerProgress) * item.height * 0.18
    });
  }
  const stackDepth = Math.min(Math.max(item.absOffset - 1, 0), 7);
  const gatherDelay = stackDepth * 0.012;
  const spreadDelay = stackDepth * 0.018;
  const gatherProgress = easeOutCubic(clamp((progress - DESKTOP_INTRO_CENTER_PHASE - gatherDelay) / (DESKTOP_INTRO_STACK_PHASE - DESKTOP_INTRO_CENTER_PHASE), 0, 1));
  const spreadProgress = easeInOutCubic(clamp((progress - DESKTOP_INTRO_STACK_PHASE - spreadDelay) / (1 - DESKTOP_INTRO_STACK_PHASE), 0, 1));
  const stackStep = clamp(item.width * 0.04, 5, 7);
  const startX = item.direction * (item.width * 0.16 + stackDepth * stackStep * 0.2);
  const startScale = Math.min(0.96, item.scale + 0.08);
  const startY = item.y - item.height * (0.08 + stackDepth * 0.005);
  const stackX = item.direction * (item.width * 1.02 + stackDepth * stackStep);
  const stackY = item.height * (0.015 + stackDepth * 0.0015);
  const stackScale = Math.max(0.8, 0.82 - stackDepth * 0.003);
  const gatheredX = startX + (stackX - startX) * gatherProgress;
  const gatheredY = startY + (stackY - startY) * gatherProgress;
  const gatheredScale = startScale + (stackScale - startScale) * gatherProgress;
  return _objectSpread(_objectSpread({}, item), {}, {
    opacity: item.opacity * clamp(gatherProgress * 1.35, 0, 1),
    scale: gatheredScale + (item.scale - stackScale) * spreadProgress,
    x: gatheredX + (item.x - stackX) * spreadProgress,
    y: gatheredY + (item.y - stackY) * spreadProgress
  });
};
const getMobileIntroItemLayout = _ref11 => {
  let item = _ref11.item,
    progress = _ref11.progress;
  if (item.isSelected) {
    const centerProgress = easeOutCubic(clamp(progress / MOBILE_INTRO_CENTER_PHASE, 0, 1));
    return _objectSpread(_objectSpread({}, item), {}, {
      opacity: centerProgress,
      y: item.y - (1 - centerProgress) * item.height * 0.78
    });
  }
  const revealStart = MOBILE_INTRO_CENTER_PHASE * MOBILE_INTRO_STACK_REVEAL_START;
  const stackRevealProgress = easeOutCubic(clamp((progress - revealStart) / (MOBILE_INTRO_CENTER_PHASE - revealStart), 0, 1));
  const sideProgress = easeInOutCubic(clamp((progress - MOBILE_INTRO_CENTER_PHASE) / (1 - MOBILE_INTRO_CENTER_PHASE), 0, 1));
  const stackDepth = Math.min(Math.max(item.absOffset - 1, 0), 1);
  const stackX = item.direction * item.width * (0.12 + stackDepth * 0.025);
  const stackY = -item.height * (0.018 + stackDepth * 0.006);
  const startScale = Math.min(0.98, item.scale + 0.12);
  return _objectSpread(_objectSpread({}, item), {}, {
    opacity: item.opacity * stackRevealProgress,
    scale: startScale + (item.scale - startScale) * sideProgress,
    x: stackX + (item.x - stackX) * sideProgress,
    y: stackY + (item.y - stackY) * sideProgress
  });
};
const getIntroItemLayout = _ref12 => {
  let isDesktop = _ref12.isDesktop,
    item = _ref12.item,
    progress = _ref12.progress;
  if (progress >= 1) {
    return item;
  }
  const safeProgress = clamp(progress, 0, 1);
  return isDesktop ? getDesktopIntroItemLayout({
    item,
    progress: safeProgress
  }) : getMobileIntroItemLayout({
    item,
    progress: safeProgress
  });
};
const createCarouselShadowStates = _ref13 => {
  let frameMetrics = _ref13.frameMetrics,
    _ref13$items = _ref13.items,
    items = _ref13$items === void 0 ? [] : _ref13$items,
    _ref13$panelLiftPx = _ref13.panelLiftPx,
    panelLiftPx = _ref13$panelLiftPx === void 0 ? 0 : _ref13$panelLiftPx,
    _ref13$panelWidth = _ref13.panelWidth,
    panelWidth = _ref13$panelWidth === void 0 ? 0 : _ref13$panelWidth,
    _ref13$surfaceHeight = _ref13.surfaceHeight,
    surfaceHeight = _ref13$surfaceHeight === void 0 ? 0 : _ref13$surfaceHeight,
    _ref13$surfaceWidth = _ref13.surfaceWidth,
    surfaceWidth = _ref13$surfaceWidth === void 0 ? 0 : _ref13$surfaceWidth;
  if (!(frameMetrics !== null && frameMetrics !== void 0 && frameMetrics.projectedShadowWidth) || !surfaceWidth || !surfaceHeight || !panelWidth) {
    return [];
  }
  const panelToSurfaceRatio = surfaceWidth / Math.max(panelWidth, 1);
  return [...items].sort((leftItem, rightItem) => leftItem.absOffset - rightItem.absOffset).slice(0, 3).map(item => {
    const depthOpacity = item.isSelected ? 0.62 : 0.22;
    const drift = frameMetrics.surfaceOffsetX + item.x * panelToSurfaceRatio;
    const itemWidthRatio = item.width / Math.max(panelWidth, 1);
    const projectedShadowWidth = frameMetrics.projectedShadowWidth * itemWidthRatio * (0.74 + item.scale * 0.24);
    const baseShadowState = getShadowState({
      drift,
      lift: panelLiftPx,
      minLift: 0,
      liftRange: Math.max(panelLiftPx, 1),
      driftRange: 0,
      baseDrift: drift,
      surfaceWidth,
      surfaceHeight,
      frameMetrics: _objectSpread(_objectSpread({}, frameMetrics), {}, {
        projectedShadowWidth
      })
    });
    return _objectSpread(_objectSpread({}, baseShadowState), {}, {
      shadowBlur: baseShadowState.shadowBlur * (item.isSelected ? 1 : 1.18),
      shadowOpacity: baseShadowState.shadowOpacity * depthOpacity * item.opacity,
      shadowScaleX: baseShadowState.shadowScaleX * (item.isSelected ? 1 : 0.86),
      shadowScaleY: Math.max(0.14, baseShadowState.shadowScaleY * (item.isSelected ? 1 : 0.82))
    });
  }).filter(shadowState => shadowState.shadowOpacity > 0.035);
};
setGlobal('svs.tickets.next.components.ticketCarousel.constants', {
  DESKTOP_MEDIA_QUERY,
  DRAG_THRESHOLD_PX,
  DRAG_TICKET_FACTOR,
  MIN_VELOCITY,
  MOMENTUM_FRAME_MS,
  MOMENTUM_FRICTION,
  SNAP_DURATION_MS,
  SNAP_THRESHOLD,
  TICKET_COUNT
});
setGlobal('svs.tickets.next.components.ticketCarousel.shared', {
  clamp,
  easeInOutCubic,
  easeOutCubic,
  getGsap
});
setGlobal('svs.tickets.next.components.ticketCarousel.selection', {
  getCarouselImageSourceKey,
  getClosestPositionForTicketNumber,
  getImageSource,
  getNearestPosition,
  getSafeTicketNumber,
  getTicketImage,
  getTicketNumberFromPosition,
  getTicketPositionFromNumber,
  getWrappedDistance
});
setGlobal('svs.tickets.next.components.ticketCarousel.layout', {
  createCarouselItems,
  createCarouselShadowStates,
  getBadgeSize,
  getDesktopArrowOffset,
  getDesktopVisibleSideCount,
  getIntroItemLayout
});
setGlobal('svs.tickets.next.components.ticketCarousel.useCarouselIntro', useCarouselIntro);
setGlobal('svs.tickets.next.components.ticketCarousel.useCarouselViewport', useCarouselViewport);

 })(window);